import {
  MAX_EMAIL_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  MAX_NAME_LENGTH,
  MAX_ONETIME_COST_CONTENTS_LENGTH,
  MAX_MONTH_MULTIPLIER,
} from "./patterns";

// エラーメッセージ生成関数
export const createRequiredMessage = (fieldName?: string) =>
  fieldName ? `${fieldName}を入力してください。` : "入力してください。";

export const createSelectRequiredMessage = (fieldName?: string) =>
  fieldName ? `${fieldName}を選択してください。` : "選択してください。";

export const createMaxLengthMessage = (length: number) => `${length}文字以内で入力してください`;

export const createMinLengthMessage = (length: number) => `${length}文字以上で入力してください`;

const createFormatInvalidMessage = (fieldName?: string) =>
  `※${fieldName ? `${fieldName}の` : ""}形式が正しくありません。`;

// メールアドレス関連
export const EMAIL_REQUIRED_MESSAGE = createRequiredMessage("メールアドレス");
export const EMAIL_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_EMAIL_LENGTH);
export const EMAIL_FORMAT_MESSAGE = createFormatInvalidMessage("メールアドレス");

// パスワード関連
export const PASSWORD_REQUIRED_MESSAGE = createRequiredMessage("パスワード");
export const PASSWORD_FORMAT_MESSAGE = createFormatInvalidMessage("パスワード");
export const PASSWORD_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_PASSWORD_LENGTH);
export const PASSWORD_MIN_LENGTH_MESSAGE = createMinLengthMessage(MIN_PASSWORD_LENGTH);
export const PASSWORD_CONFIRMATION_REQUIRED_MESSAGE = createRequiredMessage("パスワード（確認用）");
export const PASSWORD_MISMATCH_MESSAGE = "パスワードが一致しません。";

// 名前関連
export const FAMILY_NAME_REQUIRED_MESSAGE = createRequiredMessage("姓");
export const FIRST_NAME_REQUIRED_MESSAGE = createRequiredMessage("名");
export const FAMILY_NAME_KANA_REQUIRED_MESSAGE = createRequiredMessage("姓（カナ）");
export const FIRST_NAME_KANA_REQUIRED_MESSAGE = createRequiredMessage("名（カナ）");
export const KANA_FORMAT_MESSAGE = "全角カタカナで入力してください。";
export const NAME_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_NAME_LENGTH);

// 電話番号関連
export const PHONE_NUMBER_REQUIRED_MESSAGE = createRequiredMessage("電話番号");
export const SMS_PHONE_NUMBER_FORMAT_MESSAGE =
  "SMS認証に使う電話番号は、070・080・090で始まる11桁の半角数字（ハイフンなし）で入力してください。";
export const PHONE_NUMBER_FORMAT_MESSAGE = "電話番号は10桁または11桁の数字で入力してください。";

// 数値関連
export const HALF_WIDTH_NUMBER_FORMAT_MESSAGE = "半角数字で入力してください。";
export const INTEGER_FORMAT_MESSAGE = "整数で入力してください";
export const PRICE_LIMIT_MESSAGE = "入力可能な上限を超えています";
export const NON_NEGATIVE_MESSAGE = "0以上の値を入力してください";
export const MONTH_MULTIPLIER_RANGE_MESSAGE = `家賃の月数（0〜${MAX_MONTH_MULTIPLIER}）で入力してください`;

// 日付関連
export const INVALID_DATE_MESSAGE = "有効な日付を入力してください";
export const DATE_RANGE_ERROR_MESSAGE = "終了日は開始日より後の日付を選択してください。";
export const INVALID_DATE_FORMAT_MESSAGE = "日付が不正です。";
export const BEFORE_PURCHASE_DATE_MESSAGE = "購入月より前の月は選択できません。";

// その他費用内容
export const ONETIME_COST_CONTENTS_MAX_LENGTH_MESSAGE = createMaxLengthMessage(MAX_ONETIME_COST_CONTENTS_LENGTH);
